module.exports = __webpack_public_path__ + "img/5.c501163c.png";